"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.defaultPageProps = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cookieUtils = require("angieslist-app-platform/lib/common/utils/cookieUtils");
var _queryString = _interopRequireDefault(require("query-string"));
var defaultPageProps = exports.defaultPageProps = process.env.IS_BROWSER ? {
  userId: '[[user.userInfo.response.userId]]',
  kwcid: (0, _get2["default"])(_queryString["default"].parse(window.location.search), 's_kwcid') || (0, _cookieUtils.getCookie)('s_kwcid'),
  cid: (0, _get2["default"])(_queryString["default"].parse(window.location.search), 'cid')
} : {};
var defaultProps = exports.defaultProps = {
  userId: '[[user.userInfo.response.userId]]',
  userPrimaryZipCode: '[[user.primaryAddress.postalCode]]',
  userPrimaryAdZone: '[[user.primaryAddress.advertisingZone]]',
  userSelectedZipCode: '[[user.currentAddress.postalCode]]',
  userSelectedAdZone: '[[user.currentAddress.advertisingZone]]',
  pathName: '[[routing.locationBeforeTransitions.pathname]]'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/analytics/defaultAnalyticsProps.js
// module id = 2043
// module chunks = 9